import {changeEvent, dispatchCustomEvent} from "../../../../../webpack/modules/events";
import {hideOffcanvas} from "../../../../../webpack/modules-optimized/offcanvas";
import {
    hideOptionErrors,
    updatePriceElements,
    updateSizesPrices
} from "../../../../../webpack/modules-optimized/product-page";

changeEvent('#product-page input[name="support-color"]', false, function(element) {
    let container = element.closest('.product-scope');
    let offcanvas = element.closest('.offcanvas');
    let previewElement = container.querySelector(`.open-options[data-bs-target="#${offcanvas.id}"] .preview`);
    let supportColors = offcanvas.querySelectorAll('.support-color');
    let supportColor = element.nextElementSibling;

    dispatchCustomEvent(
        'productSupportColorChanged',
        {
            'option': offcanvas,
            'previewElement': previewElement,
        }
    );
    supportColors.forEach((supportColor) => supportColor.classList.remove('selected'));
    supportColor.classList.add('selected');
    if (previewElement && previewElement.classList.contains('d-none')) previewElement.classList.remove('d-none');
    hideOptionErrors(offcanvas);
    hideOffcanvas(offcanvas.id);
    updatePriceElements(container);
    updateSizesPrices(container);
});